<template>
  <swiper
    class="screen-four-swiper"
    :options="swiperOption"
  >
    <swiper-slide class="screen-four-swiper-item">
      <div class="swiper-slide-content">
        <div class="title about-title">
          <div class="title__zh">关于我们</div>
          <div class="title__en">ABOUT US</div>
          <div class="title__line"></div>
        </div>
        <div class="content">
          <div>思极星能依托 “能源+科技” 的发展模式，聚焦细分领域的科技赋能。依托线下能源服务站、绿色运力等载体，与线上能源管理、物流管理、车辆服务等功能联动，聚合人工智能、大数据、物联网、云计算等新型通信技术，打造从选址布局/运营管理、安全保障到投资规划的全业务闭环新生态，从而推动能源绿色、智能发展。</div>
        </div>
      </div>
    </swiper-slide>

    <div
      class="swiper-pagination swiper-pagination-white"
      slot="pagination"
    ></div>
  </swiper>
</template>

<script>
import Button from "@/components/button";

export default {
  components: {
    Button
  },

  data() {
    return {
      swiperOption: {
        touchRatio: 0.8,
        speed: 800,
        parallax: true
        // pagination: {
        //   el: ".swiper-pagination",
        //   clickable: true,
        //   renderBullet: (index, className) => {
        //     return `<div class="${className} full-swiper-pagination-custom-line"></div>`;
        //   }
        // }
      }
    };
  }
};
</script>

<style lang="less">
.screen-four-swiper {
  color: @white;
  height: 100%;

  &-item {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .swiper-slide-content {
    position: relative;
    display: flex;
    flex-direction: column;
    width: 900px;
    .title {
      margin: 0 auto;
      text-align: center;
      display: flex;
      flex-direction: column;
      align-items: center;
      &__zh {
        font-size: 36px;
        color: @white;
      }
      &__en {
        color: @text-primary;
        text-transform: uppercase;
      }
      &__line {
        margin-top: 8px;
        width: 30px;
        height: 3px;
        background: linear-gradient(
          90deg,
          rgba(25, 114, 242, 1) 0%,
          rgba(253, 133, 186, 1) 100%
        );
        border-radius: 10em;
      }
    }
    .content {
      font-size: 14px;
      color: rgba(102, 132, 208, 1);
      line-height: 30px;
      margin-top: 50px;
      padding: 0 40px;
      div {
        text-indent: 2em;
      }
    }
  }
}
</style>